import { type SxProps, type Theme } from "@mui/material";

import { type FieldSize } from "ui/forms/field-size";

/**
 * `FormControl` is already a flex column, so the space between label, control and messages is one
 * `gap` rather than a margin on each part — the same model the hand-rolled wrappers around
 * `ui/select` and the form builder use, and the reason `MuiFormHelperText` zeroes its own
 * `marginTop`. `gap` also ignores a conditionally rendered `null`, where a sibling-margin rule
 * would count it.
 */
export const FIELD_STACK_GAP: Record<FieldSize, number> = {
  medium: 0.75,
  small: 0.5,
};

export const FIELD_STACK_SX: Record<FieldSize, SxProps<Theme>> = {
  medium: { gap: FIELD_STACK_GAP.medium },
  small: { gap: FIELD_STACK_GAP.small },
};
